import { useIntl } from 'react-intl';
import { MediaButton, PlayPauseContainer } from './PlayPauseButton.styled';

interface PlayPauseButtonProps {
  isPlaying: boolean;
  togglePlayPause: () => void;
}

export const PlayPauseButton = ({ isPlaying, togglePlayPause }: PlayPauseButtonProps) => {
  const intl = useIntl();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      togglePlayPause();
    }
  };

  return (
    <PlayPauseContainer data-testid="play-pause-button-container" onClick={togglePlayPause}>
      <MediaButton
        data-testid="play-pause-button"
        role="button"
        tabIndex={0}
        aria-label={
          isPlaying
            ? intl.formatMessage({ id: 'pause', defaultMessage: 'Pause' })
            : intl.formatMessage({ id: 'play', defaultMessage: 'Play' })
        }
        aria-pressed={isPlaying}
        onKeyDown={handleKeyDown}
      >
        <svg data-testid="play-pause-button-icon">
          <use href={isPlaying ? '#pause' : '#play'} />
        </svg>
      </MediaButton>
    </PlayPauseContainer>
  );
};
